export type NotificationType = 'info' | 'warning' | 'error' | 'success' | 'actionRequired';
export type NotificationSource = 'system' | 'aiAgent' | 'fa' | 'client';
export type NotificationFilter = 'all' | 'unread' | 'actionRequired' | 'warnings';

export type MyClientsTabId =
  | 'client-chat'
  | 'actions'
  | 'finances'
  | 'accounts'
  | 'journey'
  | 'profile'
  | 'documents';

export interface NotificationTarget {
  route: string;
  tab?: MyClientsTabId;
  /**
   * Subject GUID to pass to createOrSelectClientConversation.
   * Prefer this over clientId — use the actual subject/client GUID here.
   */
  subjectGuid?: string;
  /**
   * @deprecated Use subjectGuid instead. Kept for backward compatibility.
   * Will be used as a fallback if subjectGuid is not set.
   */
  clientId?: string;
  clientName?: string;
}

export interface NotificationCta {
  label: string;
  target: NotificationTarget;
}

export interface AppNotification {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  createdAt: string;
  read: boolean;
  source: NotificationSource;
  clientId?: string;
  clientName?: string;
  target?: NotificationTarget;
  cta?: NotificationCta;
  dismissible: boolean;
  tags?: string[];
  metadata?: Record<string, unknown>;
}
